<template>
  <div class="manage-content">
    <div class="location">达人管理中心 / 我的订单</div>
    <div class="white-bg shadow margin-top-20 padding30 radius">
      <el-tabs v-model="activeName" @tab-click="handleClick(activeName)">
        <el-tab-pane label="进行中" name="first">
          <tab1></tab1>
        </el-tab-pane>
        <el-tab-pane label="已结束" name="second">
          <tab2></tab2>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import Tab1 from './components/Tab1'
import Tab2 from './components/Tab2'
export default {
  name: 'EnterpriseOrder',
  components: {Tab1, Tab2},
  data () {
    return {
      activeName: sessionStorage.getItem('activeName')
    }
  },
  methods: {
    handleClick (activeName) {
      sessionStorage.setItem('activeName',activeName)
    }
  },
  created () {
    if (!sessionStorage.activeName) {
      this.activeName = 'first'
    }
    window.onbeforeunload = function() {
      sessionStorage.removeItem('activeName')
    };
  }
}
</script>
<style scoped></style>
